import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultContactInfo,
  defaultCosts,
  defaultHangarBasicInfo,
  defaultHangarOtherFacilities,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const tenantHangarRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: defaultHangarBasicInfo,
  costs: defaultCosts,
  description: {
    adTitle: validationRules.adTitle,
    adDescription: validationRules.adDescription,
    adLocation: validationRules.adLocation,
  },
  contactInfo: defaultContactInfo,
  otherFacilities: defaultHangarOtherFacilities,
  connections: defaultConnections,
}
